import React, { useState } from 'react'
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react'

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  const faqs = [
    {
      question: "정말 무료인가요?",
      answer: "네, 100% 무료입니다. 광고나 숨겨진 비용 없이 고품질의 AI 트렌드 정보를 제공합니다. 다만, AI 시스템 운영 비용으로 인해 무료 구독은 선착순으로 제한될 수 있습니다."
    },
    {
      question: "영상보다 효율적인가요?",
      answer: "30분 → 3분, 10배 효율적입니다. 긴 영상에서 핵심만 추출하여 바쁜 일상 속에서도 빠르게 AI 트렌드를 파악할 수 있습니다. 텍스트 형태라 언제든 다시 참고하기도 쉽습니다."
    },
    {
      question: "영어 몰라도 되나요?",
      answer: "완벽한 한국어 번역을 제공합니다. 해외 커뮤니티의 전문 용어와 맥락까지 정확하게 번역하여, 영어를 몰라도 글로벌 AI 트렌드를 완벽하게 이해할 수 있습니다."
    },
    {
      question: "왜 Reddit인가요?",
      answer: "유튜브보다 빠른 정보가 Reddit에 있습니다. 개발자와 AI 전문가들이 실시간으로 소통하는 공간에서 가장 빠르고 정확한 정보를 얻을 수 있습니다. Hacker News, GitHub 등도 함께 모니터링합니다."
    },
    {
      question: "언제든 구독 취소할 수 있나요?",
      answer: "네, 언제든 쉽게 취소할 수 있습니다. 뉴스레터 하단의 '구독 취소' 링크를 클릭하거나, 이메일로 요청하시면 즉시 처리해드립니다. 복잡한 절차나 추가 비용은 없습니다."
    },
    {
      question: "얼마나 자주 받을 수 있나요?",
      answer: "매주 1회 정기적으로 발송됩니다. 일정한 요일과 시간에 받아보실 수 있어 루틴으로 관리하기 좋습니다. 중요한 속보가 있을 경우 추가로 발송할 수도 있습니다."
    }
  ]

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section className="py-20 bg-gray-50">
      <div className="container-width section-padding">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-primary-100 rounded-full mb-8">
            <HelpCircle className="w-10 h-10 text-primary-600" />
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            자주 묻는 <span className="text-primary-600">질문</span>
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            구독 전 궁금한 점들을 미리 확인해보세요
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden transition-all duration-300 hover:shadow-md"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-8 py-6 text-left flex items-center justify-between hover:bg-gray-50 transition-colors duration-200"
                >
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 pr-4">
                    Q: {faq.question}
                  </h3>
                  <div className="flex-shrink-0">
                    {openIndex === index ? (
                      <ChevronUp className="w-6 h-6 text-primary-600" />
                    ) : (
                      <ChevronDown className="w-6 h-6 text-gray-400" />
                    )}
                  </div>
                </button>
                
                <div className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}>
                  <div className="px-8 pb-6">
                    <div className="bg-primary-50 p-6 rounded-xl border border-primary-100">
                      <p className="text-gray-800 leading-relaxed">
                        <strong className="text-primary-600">A:</strong> {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                다른 궁금한 점이 있으신가요?
              </h3>
              <p className="text-gray-600 mb-6">
                언제든 편하게 문의해주세요. 24시간 내에 답변드리겠습니다.
              </p>
              <a 
                href="mailto:support@turings.co.kr"
                className="inline-flex items-center gap-2 bg-primary-600 hover:bg-primary-700 text-white font-medium px-6 py-3 rounded-lg transition-colors duration-200"
              >
                <HelpCircle className="w-5 h-5" />
                문의하기
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FAQ
